import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AwsAuthService } from 'src/app/services/aws-auth.service';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';
import { MyStoriesService } from 'src/app/modules/stories/services/my-stories.service';
import { UserCiamInfo } from 'src/app/interfaces/event-info.interface';
import { Location } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-self-registration',
  templateUrl: './self-registration.component.html',
  styleUrls: ['./self-registration.component.scss']
})
export class SelfRegistrationComponent implements OnInit {
  auth = Auth;
  selectedLang: string;
  eventId: string = '';
  language: string = '';
  translationData: any[] = [];
  userInfo: UserCiamInfo = <any> null;
  isSpinnerLoads: boolean = true;
  isChecked: boolean = false;
  registerUserClicked: boolean = false;
  successResponse: boolean = false;
  responseMessage: string = ''
  translatedArray = [];
  finalLang = false;
  responseInfoMessage: string = "CP_SM_REGISTER_RESPONSE_SUB_MSG";

  constructor(
    private route: ActivatedRoute,
    private awsAuth: AwsAuthService,
    private router: Router,
    private translationService: TranslationService,
    private languageService: LanguageService,
    private _myStoriesService : MyStoriesService,
    private _location : Location
  ) {  
    this.selectedLang = localStorage.getItem('language') || 'en-GB';
  }

  ngOnInit(): void {
    this.initializeEventId();
    this.language = this.languageService.getLanguage();
    this.translationService.getTranslationDataAsObservable().subscribe(
      (translationData: any) => {
        this.translationData = translationData;
      }
    ) 
  }

  public initializeEventId(): void {
    const eventId = this.route.snapshot.paramMap.get('eventId') as string;
    if (this._myStoriesService.isValidGuID(eventId)) {
      localStorage.setItem('routeUrl', '/register/' + eventId);
      this.eventId = eventId;
      sessionStorage.setItem('eventId', this.eventId);
      this.checkLoginAndFetchData()
    }else{
      this.router.navigateByUrl('/'+this.language+'/404');
    }
  }

  async checkLoginAndFetchData(): Promise<void> {
    const isLoggedIn = await this.awsAuth.checkUserLoginStatus();
    if (isLoggedIn) {
      this.getUserDetails()
    }
  }

  public getUserDetails(){
      const langInUrl = this.router.url.split('/')[1];
      if(!this.languageService.checkIsValideLanguage(langInUrl)){
        this.router.navigateByUrl('/'+this.language+'/404');
        return;
      }
    this._myStoriesService.getUserInfo(this.eventId).subscribe({
      next: (data: UserCiamInfo) => {
        if(data){
          this.updateLanguageIfNeeded(data);
          this.userInfo = data;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.handleUserInfoError(error)
      }
    })
    }
  public async  updateLanguageIfNeeded(data: UserCiamInfo) {
    const currentPath = this._location.path();
    const languageCode = currentPath.split('/')[1];

    if (languageCode != data.ciamInfo.locale && sessionStorage.getItem('languagePicked') == 'false') {
      this.languageService.setIsNotParticipantSelectedLang(false);
      this.language = this.languageService.checkIsValideLanguage(data.ciamInfo.locale)?data.ciamInfo.locale: 'en-GB'
      localStorage.setItem('language', this.language);
      this._location.go(this.router.url.replace(languageCode, this.language))
      this.getTranslations() 
    }else{
      this.isSpinnerLoads = false;
    }
    sessionStorage.setItem('languagePicked','false')
    this.languageService.setParticipantLanguage(this.language);
    this.languageService.participantLocale = data.ciamInfo.locale ?? 'de-DE';
      
    }

  public handleUserInfoError(error: HttpErrorResponse): void {
    if (error.error['error-code'] === "1412") {
      this.registerUserClicked = true;
      this.successResponse = true;
      this.responseMessage = 'CP_SM_SELF_REG_MSG';
      this.isSpinnerLoads = false;
    } else {
      this.router.navigateByUrl('/' + this.language + '/404');
    }
    }

  public getTranslations() { 
  this.language = this.languageService.getLanguage();
  this.translationService.phraseApiCallForTranslations(this.language).subscribe({
      next: (allDeTranslationBasedOnlocle: string | any[]) => { 
        for (let i = 0; i < allDeTranslationBasedOnlocle.length; i++) {
          this.translatedArray = this.translatedArray.concat(allDeTranslationBasedOnlocle[i]);
        }      
        this.translationService.setTranslationData(this.translatedArray);
        this.translationService.sendSelectedLanguage(this.language);
        this.translationService.sendtranslationValue(this.translatedArray);
        this.finalLang = true;
        this.isSpinnerLoads = false;
        return true
      },
      error: (err: any) => { 
        this.finalLang = false;
        localStorage.setItem('language', 'en-GB');
        this.getTranslations()
        return false
      }
    });
   return
     }

  public register(){
    this.isSpinnerLoads = true;
    this.registerUserClicked = true
    this._myStoriesService.registerUser(this.eventId).subscribe({
      next: (data) => {
        if(data){
          this.successResponse = true
          this.isSpinnerLoads = false; 
          this.responseMessage = 'CP_SM_SELF_REG_SUCCESS_MSG'; 
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isSpinnerLoads = false;
        this.router.navigateByUrl('/'+this.language+'/404');
      }
    })
    }
    
  async logout() {
    let eventId = sessionStorage.getItem("eventId")
    const registerUrl = `/stories/register/${eventId}`;
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('currentCIAMUser');
    localStorage.removeItem('token');     
    sessionStorage.setItem('ciamClicked','true');
    sessionStorage.setItem('languagePicked','false');
    await this.auth.signOut()
      .then((data) => {
        setTimeout(()=> {
          window.open(registerUrl, "_self");
        }, 1000);

      })  
  }

  public openTermsConditions(): void {
    const selectedLang = localStorage.getItem('language') ?? 'en-GB';
    let url = this.router.serializeUrl(this.router.createUrlTree(['/' + selectedLang + '/terms-conditions']));
    window.open(url, '_blank');
  }

}
